import Layout from "@/modules/users/users-layout"
import Schools from "@/modules/users/schools/schools-components/schools-list"
import School from "@/modules/users/schools/schools-components/schools-details"

import SchoolsUsers from "@/modules/users/schoolsusers/schoolsusers-components/schoolsusers-list"
import UserNotifications from "@/modules/users/notifications/usernotificationscomponents/user-notifications"

import Payments from "@/modules/users/payments/payments-components/payments-list"
import Payment from "@/modules/users/payments/payments-components/payments-details"

const UsersRouter = {
	path: "/users",
	name: "users",
	component: Layout,
	props: true,
	children: [
		{
			path: "referents",
			name: "users.referents",
			component: SchoolsUsers,
			props: false
		},
		{
			path: "schools/:school_id",
			name: "users.schools.school_id",
			component: School,
			props: true
		},
		{
			path: "schools",
			name: "users.schools",
			component: Schools,
			props: true
		},
		{
			path: "payments/:payment_id",
			name: "users.payments.payment_id",
			component: Payment,
			props: true
		},
		{
			path: "payments",
			name: "users.payments",
			component: Payments,
			props: true
		},
		{
			path: "notifications",
			name: "users.notifications",
			component: UserNotifications,
			props: true
		},
		{
			path: "",
			name: "users.schools",
			component: Schools,
			props: true
		}
	]
}

export default UsersRouter
